"use client";

import type { FC, Ref } from "react";
import { RealtorCard } from "@huub-web/shared";

export type RealtorCardTemplateProps = {
  /**
   * Optional image URL for the realtor
   */
  image?: string;
  /**
   * Name of the realtor
   */
  name: string;
  /**
   * Body content (supports Markdown)
   */
  body: string;
  /**
   * URL of the realtor
   */
  url: string;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * @deprecated 💀
 */
export const RealtorCardTemplate: FC<RealtorCardTemplateProps> = ({
  image,
  name,
  url,
  body,
  ref,
}) => <RealtorCard ref={ref} image={image} name={name} url={url} body={body} />;
